import { DateTime } from 'luxon';

/** Company time zone: hosts' default. */
export const HOST_TZ = 'America/Chicago';

export const TIMEZONES: [string, string][] = [
  ['America/Chicago', 'Central Time (Chicago)'],
  ['America/New_York', 'Eastern Time (New York)'],
  ['America/Indiana/Indianapolis', 'Eastern Time (Indianapolis)'],
  ['America/Denver', 'Mountain Time (Denver)'],
  ['America/Phoenix', 'Mountain Time, no DST (Phoenix)'],
  ['America/Los_Angeles', 'Pacific Time (Los Angeles)'],
  ['America/Anchorage', 'Alaska'],
  ['Pacific/Honolulu', 'Hawaii'],
  ['Europe/London', 'London'],
  ['Europe/Berlin', 'Central Europe (Berlin)'],
  ['Europe/Kyiv', 'Eastern Europe (Kyiv)'],
  ['Europe/Warsaw', 'Warsaw'],
  ['Asia/Kolkata', 'India'],
  ['Asia/Singapore', 'Singapore'],
  ['Australia/Sydney', 'Sydney'],
  ['UTC', 'UTC'],
];

/** "CDT", "EST", … for a zone right now (or at `at`). */
export const tzAbbr = (tz: string, at?: string) => (at ? DateTime.fromISO(at) : DateTime.now()).setZone(tz).toFormat('ZZZZ');

/** "Central Time (Chicago)" or the raw zone id if it isn't in the list. */
export const tzName = (tz: string) => TIMEZONES.find(([z]) => z === tz)?.[1] ?? tz.replace(/_/g, ' ');

export function TimezoneSelect({ id, value, onChange }: { id?: string; value: string; onChange: (tz: string) => void }) {
  const options = TIMEZONES.some(([z]) => z === value) ? TIMEZONES : [[value, tzName(value)] as [string, string], ...TIMEZONES];
  return (
    <select id={id} value={value} onChange={(e) => onChange(e.target.value)}>
      {options.map(([z, label]) => (
        <option key={z} value={z}>{label} · {tzAbbr(z)}</option>
      ))}
    </select>
  );
}
